import styled from 'styled-components';

export const QuickFrameStyled = styled.div`
  >a {
      :visited, :link, :hover, :active {
        height: 24px;
        color: white;
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 10001;
        font-size: 17px;
        background-color: rgb(0,0,0);
        box-shadow: 7px 9px 10px rgba(0,0,0,.4);
        color: white;
        padding: 5px;
        border-radius: 5px;

        @media only screen and (min-width : 920px) {
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      svg {
        height: 24px;
      }
    }
`

export const MetaStyles = styled.div`

`